import React, { useEffect, useState } from 'react';
import { getUploadedImagePath, Modal, useAppDispatch, useAppState } from '@nutastic/nutastic-react-app';
import { useParams } from 'react-router-dom';
import { WebsiteActions } from '../../state/actions.mjs';
import { ContentDescription } from '../ContentDetails';
import ContentNotFoundPage from './ContentNotFoundPage';
import { RelatedContentTab } from '../ContentRelations';
import TabSlider, { TabSliderContent } from '../../refactor/tabs/TabSlider';
import LoginFlow from '../modules/account/auth/LoginFlow';
import StripePaymentProcessor from '../modules/account/checkout/StripePaymentProcessor';

const componentClass = 'shopProductPage';

const ShopProductPage = () => {
    const appDispatch = useAppDispatch();
    const { isProcessing, content: { shop: shopProducts = [] } } = useAppState();
    const [showCheckoutFlow, setShowCheckoutFlow] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [hasFetched, setHasFetched] = useState(false);
    const [currentProduct, setCurrentProduct] = useState(null);
    const { id: contentId } = useParams();

    const {
        id,
        image,
        title,
        field_7: price,
        excerpt,
        core_key: coreKey
    } = currentProduct || {};

    useEffect(() => {
        setHasFetched(false);
        appDispatch({ type: WebsiteActions.LOADING_PAGE_START });
        setCurrentProduct(null);
        const product = (shopProducts || []).find(p => p?.slug === contentId);
        setActiveTab(0);
        setCurrentProduct(product);
        setTimeout(() => {
            setHasFetched(true);
            appDispatch({ type: WebsiteActions.LOADING_PAGE_DONE });
        }, 1000);
    }, [contentId]);

    const onPurchaseClick = () => {
        setShowCheckoutFlow('LOGIN');
    };

    const renderProductPurchaseFlow = () => {
        return <StripePaymentProcessor guestEmail="testing@thelocation.com" products={[
            { id, productKey: 'test', coreKey: coreKey, type: 'digital'}
        ]} />;
    };

    const tabs = currentProduct ? [
        { label: 'Details', key: 0, children: <ContentDescription description={excerpt || 'No Description'} /> },
    ] : [ { key: 0, label: 'Loading', children: '...'} ];

    return <React.Fragment>
        {
            (!!currentProduct && !isProcessing) ? <article className={componentClass}>
                <div className={`${componentClass}__header`}>
                    <img src={getUploadedImagePath(image)} alt={currentProduct?.title} className={`${componentClass}__musicCover`} />
                    <div className={`${componentClass}__headerInfo musicLayout`}>
                        <h1>{ title }</h1>
                        <p>{ excerpt }</p>
                        <div className="buttons">
                            <button className="btn btn-outline-white bg-red" onClick={onPurchaseClick}><span>${ price} | Purchase</span> <i className="fa fa-rocket" /></button>
                        </div>
                    </div>
                </div>
                <div className={`${componentClass}__shopDetails`}>
                    <TabSlider tabs={tabs} onChange={setActiveTab} activeKey={activeTab} />
                    <div className="container">
                        <TabSliderContent tabs={tabs} activeKey={activeTab} />
                    </div>
                </div>
            </article> : <ContentNotFoundPage isProcessing={isProcessing || !hasFetched} />
        }
        { !!showCheckoutFlow && <Modal show={true} nodeId="root" className="checkoutFlowModal" closeOnOuterClick={true} onClose={() => setShowCheckoutFlow(false)}>
            { showCheckoutFlow === 'LOGIN' ? <LoginFlow onComplete={v => setShowCheckoutFlow('CHECKOUT')} /> : renderProductPurchaseFlow() }
        </Modal> }
    </React.Fragment> ;
};

export default ShopProductPage;
